/**
 * "Maths from a photo" (18 Oct): any surface (the slash menu, an equation block) asks Ask Lilia
 * to read maths from a photo. The page opens the dock on the prefill event; the panel opens its
 * file picker and sends the photo as a maths turn. Like the prefill, the request waits here until
 * a panel takes it, so it isn't lost when the dock was closed.
 */
import { ASK_PREFILL_EVENT } from "./askPrefill";

export const ASK_MATH_PHOTO_EVENT = "lilia:ask-math-photo";

let pending = false;

export function askMathFromPhoto(): void {
  pending = true;
  // The page opens the dock on the prefill event; the panel, open or opening, hears this one.
  window.dispatchEvent(new CustomEvent(ASK_PREFILL_EVENT, { detail: { message: "" } }));
  window.dispatchEvent(new CustomEvent(ASK_MATH_PHOTO_EVENT));
}

/** Whether a photo request is waiting for a panel, once. */
export function takeAskMathPhoto(): boolean {
  const p = pending;
  pending = false;
  return p;
}

/** Typed with an image attached, this asks to read maths rather than to talk about the image. */
export function isMathReadIntent(text: string): boolean {
  return /\b(equations?|formulas?|formulae|maths?|latex|tex|handwriting|transcribe)\b|équation|formule|ecuaci[oó]n|f[oó]rmula|matem/i.test(text);
}
